import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";

import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AgeGate } from "@/components/AgeGate";
import { ScrollToTop } from "@/components/ScrollToTop";
import { ChatWidget } from "@/components/ChatWidget";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import About from "@/pages/About";
import Events from "@/pages/Events";
import Contact from "@/pages/Contact";
import AreasServed from "@/pages/AreasServed";
import AreaGuide from "@/pages/AreaGuide";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import SignUp from "@/pages/SignUp";
import Waiver from "@/pages/Waiver";
import Media from "@/pages/Media";
import Visit from "@/pages/Visit";
import Admin from "@/pages/Admin";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain min-h-screen bg-ink font-body text-white">
      <BrowserRouter>
        <ScrollToTop />
        <AgeGate />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/media" element={<Media />} />
            <Route path="/areas-served" element={<AreasServed />} />
            <Route path="/dispensary/:slug" element={<AreaGuide />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/visit" element={<Visit />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/waiver" element={<Waiver />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <ChatWidget />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#141414", border: "1px solid rgba(212,175,55,0.3)", color: "#fff", borderRadius: 0 } }} />
    </div>
  );
}

export default App;
